import { towns } from "../data/towns";
import { blogPosts } from "../data/blogPosts";

// Single source of truth for route slug lists. Consumed by App.tsx (route
// generation) and the SEO route registry (sitemap + prerender). Keeping these
// derived from the data files prevents the town/route/sitemap drift that used
// to require editing three places by hand.

/** All town slugs, derived from towns.ts. */
export const townSlugs: string[] = towns.map((t) => t.slug);

/** All Help Hub article slugs, derived from blogPosts metadata. */
export const blogSlugs: string[] = blogPosts.map((p) => p.slug);
